// src/featureFlags.ts
var e = {
	"a-c-forward": !1,
	"activity-log-filters": !0,
	"ada-chat-channel": !1,
	"agent-activity-log": !1,
	"agent-copilot": !1,
	"agent-copilot-auto-translate": !1,
	"agent-copilot-trial-eligibility": !1,
	"allow-integration-api-token-usage": !1,
	"allow-same-origin-in-sandboxed-custom-card-iframe": !1,
	"analytics-custom-dashboards": !1,
	"authorization-custom-role": !1,
	"automation-ai-agent-single-interaction-action": !1,
	"automation-automation-ai-agent": !1,
	"automation-cel-expression": !1,
	"automation-intent-detection-action": !1,
	"automation-transcription-completed-trigger": !0,
	automations: !1,
	"chatbot-quota-page": !1,
	"chatbots-integration-settings": !1,
	"contact-activity-log": !1,
	"contact-memories-conversation-view": !1,
	"conversation-assistant-for-dixa-messenger": !1,
	"conversation-right-sidebar-visibility": !0,
	"conversations-view-customization": !1,
	"csat-for-dixa-messenger": !1,
	"csat-for-email": !1,
	"csat-for-widget-chat": !1,
	"custom-analytics": !0,
	"custom-attributes-suggestions": !1,
	"custom-away-status": !1,
	"desktop-app-notice-modal": !0,
	"dev-api-authorization-scopes": !0,
	"digitalgenius-chat-channel": !1,
	"dixa-rewind": !1,
	"elevio-suggestions": !1,
	"email-channel": !0,
	"email-templates-customization": !1,
	"enable-call-recordings": !0,
	"enable-restricted-queues": !1,
	"export-conversations": !1,
	"facebook-messenger-channel": !0,
	"generic-api-messaging-channel": !0,
	"has-bulk-operations": !1,
	"has-chat-with-dixa-support": !0,
	"has-custom-form-tel-email-fields": !1,
	"has-messenger": !0,
	"instagram-management": !0,
	"integrations-for-dixa-messenger": !1,
	"integrations-for-email": !0,
	"integrations-for-phone": !0,
	"intent-detection": !1,
	"intent-detection-character-limit": 300,
	"kindly-chat-channel": !1,
	"knowledge-access": !0,
	"knowledge-articles-ai-auto-translations": !1,
	"knowledge-internal-only-collections": !1,
	"knowledge-management-nav": !1,
	"knowledge-seo-meta": !1,
	"knowledge-suggestions": !0,
	"legacy-presence-sidebar": !0,
	"message-auto-redaction": !1,
	"mim-automation-variant": !1,
	"mim-chatbot": !1,
	"mim-conversation-data-source": !1,
	"mim-drafts": !1,
	"mim-integration-tools-shopify": !0,
	"mim-knowledge-kb-collections": !1,
	"mim-markdown": !0,
	"mim-one-settings-page": !1,
	"mim-sidekick": !1,
	"mim-versioning": !0,
	"mim-web-kb-max-links-access": !1,
	"new-search-conversations-view": !0,
	"new-topbar": !0,
	"organizations-sidebar": !1,
	"partner-integrations-data-sync-peopleware": !1,
	"partner-integrations-shopify-sales-attribution": !1,
	"phone-channel": !0,
	"redact-messages": !1,
	"scheduled-conversations": !1,
	"settings-add-ons-page": !0,
	"settings-integrations-revamp": !1,
	"shopify-marketplace-app": !1,
	"show-tracking-card": !0,
	"sidebar-cards-admin-management": !1,
	"smart-article-create": !1,
	"smart-article-create-multi-conversation": !1,
	"sms-channel": !1,
	"sms-compose": !1,
	"survey-advanced-customization": !1,
	"tag-suggestions-enabled": !1,
	"telephony-numbers-data-residency-regions": !1,
	"templates-language-translation-control": !1,
	"trustpilot-channel": !0,
	"use-birdeatsbug": !1,
	"use-cleaned-up-telephony-middleware": !1,
	"voice-ai-agent-action": !1,
	"voice-transcriptions-settings": !1,
	"warm-transfer-to-queue": !0,
	"website-data-source": !1,
	"whatsapp-channel": !0,
	"widget-chat-channel": !1,
	"yotpo-channel": !0
};
export { e as default, e as defaultFeatureFlags };

//# sourceMappingURL=featureFlags.js.map